import type { Texture } from 'pixi.js';
import { defaultArtShape, shapeFromAlpha, type ArtShape } from '../../logic/road/landmarks';

/** The grid a painting is read at: enough to weigh it, cheap to read. */
const GRID = 96;
const shapes = new WeakMap<object, ArtShape>();

/**
 * How a landmark's painting fills its texture (see {@link shapeFromAlpha}),
 * read once from its pixels and kept. Falls back to a typical shape when
 * the pixels can't be read.
 */
export function artShape(texture: Texture): ArtShape {
  const known = shapes.get(texture);
  if (known) return known;
  let shape = defaultArtShape(texture.width, texture.height);
  try {
    const image = texture.source.resource as CanvasImageSource | undefined;
    if (image && typeof document !== 'undefined') {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = GRID;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (ctx) {
        const k = texture.source.resolution ?? 1;
        const f = texture.frame;
        ctx.drawImage(image, f.x * k, f.y * k, f.width * k, f.height * k, 0, 0, GRID, GRID);
        shape = shapeFromAlpha(
          ctx.getImageData(0, 0, GRID, GRID).data,
          GRID,
          GRID,
          texture.width,
          texture.height,
        );
      }
    }
  } catch {
    // Keep the typical shape.
  }
  shapes.set(texture, shape);
  return shape;
}
